import { formatOperationalTime } from "../utils/Utils";
import { UNITS } from "../constants/globalStrings";
import { getCleaningMetricsValues } from "./cleaningMetricsValues.config";
import { ReactComponent as OperationalTimeIcon } from "../assets/operational_time.svg";
import { ReactComponent as RecoveryIcon } from "../assets/Recovery.svg";
import { ReactComponent as FluxIcon } from "../assets/Flux.svg";
import { ReactComponent as BackwashIcon } from "../assets/Backwash.svg";
import { ReactComponent as CebIntervalIcon } from "../assets/time_btw_ceb.svg";

const CLEANING_METRICS_CARDS = [
  {
    key: "operational_time",
    titleKey: "cleaningMetrics.operationalTime",
    unit: UNITS.HOURS,
    icon: OperationalTimeIcon,
    formatValue: formatOperationalTime,
    infoKey: "cleaningMetrics.operationalTimeInfo",
  },
  {
    key: "water_recovery",
    titleKey: "cleaningMetrics.recovery",
    unit: UNITS.PERCENTAGE,
    icon: RecoveryIcon,
    infoKey: "cleaningMetrics.recoveryInfo",
  },
  {
    key: "bw_interval",
    titleKey: "cleaningMetrics.backwashInterval",
    unit: UNITS.MINUTES,
    icon: BackwashIcon,
    infoKey: "cleaningMetrics.backwashIntervalInfo",
  },
  {
    key: "flux",
    titleKey: "cleaningMetrics.flux",
    unit: UNITS.FLUX,
    icon: FluxIcon,
    infoKey: "cleaningMetrics.fluxInfo",
  },
  {
    key: "ceb_interval",
    titleKey: "cleaningMetrics.cebInterval",
    unit: UNITS.HOURS,
    icon: CebIntervalIcon,
    infoKey: "cleaningMetrics.cebIntervalInfo",
  },
];

const formatMetricValue = (card, value) => {
  if (value === null || value === undefined) return "";
  if (card.formatValue) return card.formatValue(value);
  return `${Number(value).toFixed(1)} ${card.unit}`;
};

export const getCleaningMetricsCardsConfig = (response, t) => {
  const values = getCleaningMetricsValues(response);

  return CLEANING_METRICS_CARDS.filter((card) => {
    const metric = values[card.key];
    return metric.value !== null && metric.value !== undefined;
  }).map((card) => {
    const metric = values[card.key];

    return {
      ...card,
      rawValue: metric.value,
      title: t(card.titleKey),
      value: formatMetricValue(card, metric.value),
      infoDescription: t(card.infoKey),
      targetLabel: metric.target ? `${t("cleaningMetrics.target")}:` : "",
      targetValue: metric.target ? `${metric.target} ${card.unit}` : "",
      rangeLabel: metric.acceptable_range
        ? `${t("cleaningMetrics.acceptableRange")}:`
        : "",
      rangeValue: metric.acceptable_range
        ? `${metric.acceptable_range} ${card.unit}`
        : "",
    };
  });
};
